import React from 'react';
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import Footer from "../components/Footer";
import AnhDuongTalentPage from "../components/AnhDuongTalentPage";

const TeachersPage = () => {
    return (
        <Layout pageTitle="Ánh Dương | Ánh Dương Talent">
            <NavOne />
            <AnhDuongTalentPage />
            <Footer />
        </Layout>
    );
};

export default TeachersPage;
